'use client'

import { useIsDesktop } from '@repo/ui/hooks'
import Image from 'next/image'
import { useEffect, useState } from 'react'

export const SquareTokenResponsiveImage = () => {
  const isDesktop = useIsDesktop()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Don't render anything until client-side hydration is complete
  if (!mounted) {
    return null
  }

  return isDesktop ? (
    <Image
      src={'/images/square/square-landing.webp'}
      alt='Square Token Sell'
      width={1200}
      height={860}
      className='mx-auto'
    />
  ) : (
    <Image
      src={'/images/square/square-landing-mobile.webp'}
      alt='Square Token Sell'
      width={233}
      height={472}
      className='mx-auto'
    />
  )
}
